// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jr-z","tooltipWrapper":"Kr-z","icon":"Lr-z","tooltip":"Mr-z","content":"Nr-z"};